import React from 'react';
import PropTypes from 'prop-types';

import { BreedPropTypes } from 'dpl/shared/utils/customPropTypes';
import { isMobileUA } from 'dpl/shared/utils';
import SmartImage from 'dpl/components/SmartImage';
import HorizontalSlider from 'dpl/components/HorizontalSlider';

const IMAGE_LENGTH = isMobileUA() ? '200px' : '300px';

/** @param {any} props */
export default function BreederProfileSuggestedBreedsList({
  suggestedBreeds,
  title = 'Browse other breeds'
}) {
  return (
    <div>
      <p className="mb6 title">{title}</p>
      <HorizontalSlider
        arrowClassName="fw-medium"
        containerClassName="row flex-nowrap"
        iconClassName="f5 fw-medium black bg-white ph2 pv2 br-100 absolute box-shadow-strong"
        leftArrowClassName="BreederProfileSuggestedBreedsList__leftArrow"
        persistentArrows
        rightArrowClassName="BreederProfileSuggestedBreedsList__rightArrow"
      >
        {suggestedBreeds.map(breed => (
          <div className="col ws-normal" key={breed.id}>
            <a href={breed.url}>
              <div className="relative f0 br2 overflow-hidden">
                <SmartImage
                  Tag="div"
                  crop
                  alt={breed.name}
                  className="mw-100 cover bg-center"
                  width={IMAGE_LENGTH}
                  height={IMAGE_LENGTH}
                  loadingClass="bg-light-gray"
                  src={breed.secondary_photo_url}
                />
                <div className="w-100 h-100 absolute top-0 left-0 scrim--gradient-black">
                  <p className="transform-center-x bottom-1 white f4 tc">
                    {breed.name}
                  </p>
                </div>
              </div>
            </a>
          </div>
        ))}
      </HorizontalSlider>
    </div>
  );
}

BreederProfileSuggestedBreedsList.propTypes = {
  suggestedBreeds: PropTypes.arrayOf(PropTypes.shape(BreedPropTypes))
    .isRequired,
  title: PropTypes.string
};
